export default __webpack_public_path__ + "static/media/plus.bded6fd2.svg";